import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Selector from "canvas-core-react/lib/Selector";
import * as instanceActions from "../../../../Redux/api";
import CountriesComponent from "../../../shared/countries";
import { MOD_PROVID, WRITE } from "../../../../permissions/";
import { getRoles } from "../../../../Redux/reducer/session";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  getAchBanks,
  getOneProvider,
} from "../../../../Redux/reducer/providers";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import * as CountriesActions from "../../../../Redux/actions/countriesActions";
import {
  errorContainer,
  loadingHtml,
  moduleAction,
  sucessInfoModal,
  invalidPhoneNumber,
} from "../../../utils/functions";
import Tooltip from "canvas-core-react/lib/Tooltip";
import iconEdit from "../../../../../static/images/icon-addnew-18px.svg";
import equis from "../../../../../static/images/X.svg";
import { withTranslation } from "react-i18next";
import ProviderIdType from "../../../shared/provider/providerIdType";
import ErrorMessage from "../../../shared/custom-components/errorMessage";
import CustomInput from "../../../shared/custom-components/customInput";
import { getCountries } from "../../../../Redux/reducer/countries";

export class ProviderProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: true,
        content: loadingHtml(),
        onClose: undefined,
      },
      contentReady: false,
      institution: {},
      originalStringObject: {},
      readOnly: true,
      errors: {},
      selectedInfo: {},
    };

    this.onCancelEdit = this.onCancelEdit.bind(this);
  }

  componentDidMount() {
    const {
      countries,
      match: { params },
      actions: { getProviderById },
      countryActions: { getCountries },
    } = this.props;
    const { modal } = this.state;
    modal.show = true;
    this.setState({ modal });

    return getProviderById(params.id, params.companyId)
      .then((institution) => {
        modal.show = false;
        const providerInfo = this.getProviderInfo(institution.data);
        this.setState({
          modal,
          institution: providerInfo,
          originalStringObject: JSON.stringify(providerInfo),
          contentReady: true,
        });

        if (institution.data.country.code === "PA") {
          this.loadBanks(institution.data.country.code);
        }

        if (countries.length <= 0) {
          getCountries();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  componentWillUnmount() {
    this.setState({ contentReady: false, institution: {} });
  }

  loadBanks(country) {
    const {
      actions: { getACHBanks },
    } = this.props;
    return getACHBanks(country);
  }

  getProviderInfo = (institution) => {
    const providerAccount =
      Array.isArray(institution.provider.accounts) &&
      institution.provider.accounts[0] !== undefined
        ? institution.provider.accounts[0]
        : null;

    return {
      businessIdType:
        null != institution.businessIdType ? institution.businessIdType : "",
      countryId:
        null != institution.provider && null != institution.provider.country.id
          ? institution.provider.country.id
          : "",
      countryCode:
        institution.country !== undefined ? institution.country.code : "",
      companyName:
        null != institution.companyName ? institution.companyName : "",
      residenceCity:
        null != institution.provider.residenceCity
          ? institution.provider.residenceCity
          : "",
      address:
        null != institution.provider.address
          ? institution.provider.address
          : "",
      notificationNameProvider:
        null != institution.provider.notificationNameProvider
          ? institution.provider.notificationNameProvider
          : "",
      accountType: null !== providerAccount ? providerAccount.accountType : "",
      accountNumber:
        null !== providerAccount
          ? null != providerAccount.accountNumber
            ? providerAccount.accountNumber
            : ""
          : "",
      accountIntermediaryBank:
        null !== providerAccount
          ? null != providerAccount.accountIntermediaryBank
            ? providerAccount.accountIntermediaryBank
            : ""
          : "",
      businessId: institution.businessId,
      phoneProvider:
        null !== institution.provider.phoneProvider
          ? institution.provider.phoneProvider
          : "",
      name:
        null !== institution.provider.country.name
          ? institution.provider.country.name
          : "",
      notificationEmailProvider:
        null !== institution.provider.notificationEmailProvider
          ? institution.provider.notificationEmailProvider
          : "",
      bicDestinationBank:
        null !== providerAccount
          ? null != providerAccount.bicDestinationBank
            ? providerAccount.bicDestinationBank
            : ""
          : "",
      bicIntermediaryBank:
        null !== providerAccount
          ? null != providerAccount.bicIntermediaryBank
            ? providerAccount.bicIntermediaryBank
            : ""
          : "",
      accountCurrency:
        null !== providerAccount ? providerAccount.accountCurrency : "",
      status: institution.provider.status,
      toBillDiscount: institution.provider.toBillDiscount,
      legalSignerWrappers: institution.provider.legalSignerWrappers,
      globalApproval: institution.provider.globalApproval,
    };
  };

  SelectedChange = (event) => {
    const { selectedInfo } = this.state;

    const value = event.target.value;
    const name = event.target.name;
    selectedInfo[name] = value;

    this.setState({ selectedInfo });
  };

  handlerChange = (event) => {
    const { name, value } = event.target;
    const { institution } = this.state;

    institution[name] = value;

    if (name === "accountType") {
      // Limpiamos campos intermediarios
      institution.bicDestinationBank = "";
      institution.bicIntermediaryBank = "";
      institution.accountIntermediaryBank = "";
    }

    const errors = this.state.errors;

    if (institution[name] !== "" && errors[name] !== "") {
      delete errors[name];
    }

    const businessId = institution["businessId"];

    if (
      name === "businessIdType" &&
      errors["businessId"] !== "" &&
      businessId !== ""
    ) {
      delete errors["businessId"];
    }

    this.setState({ errors, institution });
  };

  validForm = () => {
    const { t } = this.props;
    const { institution } = this.state;

    const businessId = institution["businessId"];

    const errors = {};

    if (institution["businessIdType"] === "DIMEX" && businessId) {
      if (businessId.length !== 12 || !/^\d+$/.test(businessId)) {
        errors["businessId"] = t(`providers.manual.errors.idInvalid`);
      }
    } else if (institution["businessIdType"] !== "DIMEX" && !businessId) {
      errors["businessId"] = t(`providers.manual.errors.idRequired`);
    } else if (institution["businessIdType"] === "DIMEX" && !businessId) {
      errors["businessId"] = t(`providers.manual.errors.required`);
    }

    if (businessId.includes("%"))
      errors["businessId"] = t(`providers.manual.errors.idSpecialSimbols`);

    const signers = institution.legalSignerWrappers;
    signers.forEach((signer, index) => {
      if (signer.signerName && !signer.signerIdentification) {
        errors[`signerId-${index}`] = t(`providers.manual.errors.required`);
      } else {
        delete errors[`signerId-${index}`];
      }

      if (signer.signerIdentification && !signer.signerName) {
        errors[`signerName-${index}`] = t(`providers.manual.errors.required`);
      } else {
        delete errors[`signerName-${index}`];
      }

      if (!signer.signerName && !signer.signerIdentification) {
        delete errors[`signerId-${index}`];
        delete errors[`signerName-${index}`];
      }
    });

    const options = [
      "phoneProvider",
      "address",
      "countryId",
      "notificationNameProvider",
      "notificationEmailProvider",
      "residenceCity",
      "companyName",
    ];

    //required validation
    options.forEach((name) => {
      if (institution[name] === "" || institution[name] === 0)
        errors[name] = t(`providers.manual.errors.required`);
    });

    const phoneRef = "phoneProvider";

    if (!errors[phoneRef] && invalidPhoneNumber(institution[phoneRef]))
      errors[phoneRef] = t(`general.formErrors.invalidPhoneNumber`);

    this.setState({ errors, institution });

    return Object.keys(errors).length === 0;
  };

  handlerSignersChange = (event, id, type) => {
    // remove ref and edit with setState
    const institution = this.state.institution;
    const { value } = event.target;
    if (!institution.legalSignerWrappers[id]) {
      institution.legalSignerWrappers[id] = { [type]: value };
    } else {
      institution.legalSignerWrappers[id] = {
        ...institution.legalSignerWrappers[id],
        [type]: value,
      };
    }

    if (!value) {
      institution.legalSignerWrappers = institution.legalSignerWrappers.filter(
        ({ signerIdentification = "", signerName = "" }) =>
          signerIdentification || signerName
      );
    }

    this.setState({ institution });
  };

  getSubmitData = () => {
    const { institution, selectedInfo } = this.state;

    return {
      businessId: institution.businessId,
      countryId: institution.countryId,
      name: institution.companyName,
      businessIdType: institution.businessIdType,
      notificationProvider: {
        notificationEmail: institution.notificationEmailProvider,
        notificationName: institution.notificationNameProvider,
        phone: institution.phoneProvider,
      },
      provider: {
        accounts: [
          {
            accountCurrency:
              selectedInfo.accountCurrency === undefined
                ? institution.accountCurrency
                : selectedInfo.accountCurrency,
            accountIntermediaryBank:
              institution.accountIntermediaryBank === ""
                ? ""
                : institution.accountIntermediaryBank,
            accountNumber: institution.accountNumber,
            accountType:
              selectedInfo.accountType === undefined
                ? institution.accountType
                : selectedInfo.accountType,
            bicDestinationBank:
              institution.bicDestinationBank === ""
                ? ""
                : institution.bicDestinationBank,
            bicIntermediaryBank:
              institution.bicIntermediaryBank === ""
                ? ""
                : institution.bicIntermediaryBank,
            iban: true,
          },
        ],
        address: institution.address,
        residenceCity: institution.residenceCity,
        status:
          selectedInfo.status === undefined
            ? institution.status
            : selectedInfo.status,
        toBillDiscount:
          selectedInfo.toBillDiscount === undefined
            ? institution.toBillDiscount
            : selectedInfo.toBillDiscount,
        legalSignerRequests: institution.legalSignerWrappers.filter(
          (signer) => signer !== null
        ),
      },
    };
  };

  enableActionsButton = () => {
    const { institution, originalStringObject } = this.state;
    const NewUpdateStringObject = JSON.stringify(institution);

    if (
      institution.toBillDiscount === true &&
      institution.legalSignerWrappers.length < 1
    ) {
      return false;
    }

    return originalStringObject !== NewUpdateStringObject;
  };

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.content = null;
    modal.onClose = undefined;
    this.setState({ modal });
  };

  nextStep = () => {
    this.props.history.push("/bscadministrator/providers");
  };

  modalFunction = () => {
    const buttons = {
      SelBtn: {
        text: "Aceptar",
        action: this.nextStep,
      },
    };
    let content = null;
    if (this.state.selectedInfo.status === "DELETED") {
      content = sucessInfoModal(
        "Proveedor Eliminado",
        `El Proveedor a sido eliminado con éxito.
        Esta acción requiere ser aprobada para que el proceso de eliminación se complete..`,
        buttons
      );
    } else {
      content = sucessInfoModal(
        "Usuario",
        `Los datos del proveedor han sido actualizados con éxito.
        Diríjase al menú de admisiones para su aprobación.`,
        buttons
      );
    }
    this.setState({ modal: { content, show: true } });
  };

  UpdateProvider = (event) => {
    const {
      match: { params },
      instance: { instanceAction },
      t,
    } = this.props;

    event.preventDefault();
    if (!this.validForm()) return;

    const { modal } = this.state;
    modal.show = true;
    modal.content = loadingHtml();
    this.setState({ modal });

    return instanceAction(
      `providers/${params.companyId}/${params.id}`,
      "put",
      this.getSubmitData()
    )
      .then(() => {
        this.modalFunction();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message || "Error",
            notification.description,
            {
              continueBtn: {
                text: t("general.buttons.continue"),
                action: () => this.closeModal(),
              },
            }
          );
        }
        modal.onClose = () => this.closeModal();
        this.setState({ modal });
      });
  };

  onCancelEdit() {
    const { originalStringObject } = this.state;
    this.setState({
      readOnly: true,
      institution: JSON.parse(originalStringObject),
      errors: {},
    });
  }

  goBack() {
    this.props.history.push(`/bscadministrator/providers`);
  }

  pendingData = (attribute) => {
    const { institution } = this.state;
    const providerComplete = { ...this.props.providerInfo };
    const data =
      providerComplete?.recordTmps !== null
        ? {
            ...providerComplete?.recordTmps[0]?.data,
            companyName: providerComplete?.recordTmps[0]?.data?.name,
          }
        : null;
    return (
      data !== null &&
      data[attribute] !== undefined &&
      data[attribute] !== institution[attribute] && (
        <div className="flex-element">
          <label className="edited-client-info" htmlFor={attribute}>
            Espacio pendiente de aprobación
          </label>
          <div className="left-flex fix-tooltip">
            <Tooltip
              id="tooltip-id"
              closeButtonLabel="Close Tooltip"
              infoButtonLabel="Info"
              heading={"Pendiente de aprobación"}
            >
              <label
                className="edited-client-info tooltip-color"
                htmlFor={attribute}
              >
                De aprobarse el cambio este campo cambiaría su valor de{" "}
                {institution[attribute]} por {data[attribute]}
              </label>
            </Tooltip>
          </div>
        </div>
      )
    );
  };

  render() {
    const { institution, contentReady, readOnly, modal, errors } = this.state;
    const { t } = this.props;

    const { generalInformation } = t(["providers.detail"], {
      returnObjects: true,
    });

    const { buttons, edit, title, details, states } = {
      edit: t("notification.form.edit"),
      title: `${t("providers.title")} - ${t("profile")}`,
      details: t("formDetails", { returnObjects: true }),
      states: t("general.states", { returnObjects: true }),
      buttons: t("general.buttons", { returnObjects: true }),
    };

    return (
      <div className="provider-bsc-profile">
        <ReactTitle title={title} />
        {contentReady && (
          <Fragment>
            <h3>{generalInformation}</h3>
            {moduleAction(this.props.roles, MOD_PROVID, WRITE) && (
              <div>
                {readOnly === true ? (
                  <div className="new-edit-div-client provider-div">
                    <p
                      className="new-edit-provider"
                      onClick={() => this.setState({ readOnly: false })}
                    >
                      {edit}
                    </p>
                    <img
                      src={iconEdit}
                      className="iconEdit"
                      onClick={this.props.changeInfo}
                    />
                  </div>
                ) : (
                  <Link to={`/bscadministrator/providers`}>
                    <img
                      src={equis}
                      className="iconX-client provider-x"
                    />
                  </Link>
                )}
              </div>
            )}
            <div className="row">
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.company}
                  name="companyName"
                  value={institution.companyName}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.companyName}
                />
                {this.pendingData("companyName")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label" htmlFor="status">
                  {details.state}
                </label>
                {institution.status === "TRANSITORY" ? (
                  <input
                    className="input input--text input-w-aux__input input--active"
                    type="text"
                    id="status"
                    name="status"
                    value={states.PENDING}
                    readOnly={true}
                  />
                ) : (
                  <Selector
                    id="status"
                    label=""
                    className="no-label"
                    name="status"
                    onChange={this.handlerChange}
                    disabled={readOnly}
                    value={institution.status}
                  >
                    {["ACTIVE", "INACTIVE", "DELETED", "REJECTED"].map(
                      (value) => (
                        <option key={value} value={value}>
                          {states[value]}
                        </option>
                      )
                    )}
                  </Selector>
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <ProviderIdType
                  disabled={readOnly}
                  value={institution.businessIdType}
                  payMethod={institution.accountType}
                  country={institution.countryCode}
                  name="businessIdType"
                  onChange={this.handlerChange}
                  error={errors.businessIdType}
                />
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.id}
                  name="businessId"
                  value={institution.businessId}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.businessId}
                />
              </div>

              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.residence}
                  name="address"
                  value={institution.address}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.address}
                />
                {this.pendingData("address")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.phone}
                  name="phoneProvider"
                  value={institution.phoneProvider}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.phoneProvider}
                />
                {this.pendingData("phoneProvider")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.cityRes}
                  name="residenceCity"
                  value={institution.residenceCity}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.residenceCity}
                />
                {this.pendingData("residenceCity")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label
                  className={`label ${
                    errors.countryId ? "error-text-color" : ""
                  }`}
                  htmlFor="countryRes"
                >
                  {details.countryRes}
                </label>
                {readOnly ? (
                  <input
                    className="input input--text input-w-aux__input input--active"
                    type="text"
                    name="name"
                    id="name"
                    value={institution.name}
                    readOnly={true}
                  />
                ) : (
                  <>
                    <CountriesComponent
                      name="countryId"
                      value={institution.countryId}
                      valueAttr={`id`}
                      onChange={this.handlerChange}
                      readOnly={readOnly}
                      error={errors.countryId}
                    />

                    {errors.countryId && (
                      <ErrorMessage error={errors.countryId} />
                    )}
                  </>
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.mainContact}
                  name="notificationNameProvider"
                  value={institution.notificationNameProvider}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.notificationNameProvider}
                />
                {this.pendingData("notificationNameProvider")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <CustomInput
                  label={details.emailNotifications}
                  name="notificationEmailProvider"
                  value={institution.notificationEmailProvider}
                  readOnly={readOnly}
                  onChange={this.handlerChange}
                  error={errors.notificationEmailProvider}
                />
                {this.pendingData("notificationEmailProvider")}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryName}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signers1"
                  name="signers1"
                  type="text"
                  autoComplete="off"
                  placeholder={t(
                    "providers.manual.form.signersName.placeholder"
                  )}
                  value={
                    institution.legalSignerWrappers[0] !== undefined
                      ? institution.legalSignerWrappers[0].signerName
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 0, "signerName")
                  }
                  readOnly={readOnly}
                />
                {errors["signerName-0"] && (
                  <ErrorMessage error={errors["signerName-0"]} />
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryID}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signersId1"
                  name="signersId1"
                  type="text"
                  autoComplete="off"
                  placeholder={t("providers.manual.form.signersId.placeholder")}
                  value={
                    institution.legalSignerWrappers[0] !== undefined
                      ? institution.legalSignerWrappers[0].signerIdentification
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 0, "signerIdentification")
                  }
                  readOnly={readOnly}
                />
                {errors["signerId-0"] && (
                  <ErrorMessage error={errors["signerId-0"]} />
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryName}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signers2"
                  name="signers2"
                  type="text"
                  autoComplete="off"
                  placeholder={t(
                    "providers.manual.form.signersName.placeholder"
                  )}
                  value={
                    institution.legalSignerWrappers[1] !== undefined
                      ? institution.legalSignerWrappers[1].signerName
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 1, "signerName")
                  }
                  readOnly={readOnly}
                />
                {errors["signerName-1"] && (
                  <ErrorMessage error={errors["signerName-1"]} />
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryID}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signersId2"
                  name="signersId2"
                  type="text"
                  autoComplete="off"
                  placeholder={t("providers.manual.form.signersId.placeholder")}
                  value={
                    institution.legalSignerWrappers[1] !== undefined
                      ? institution.legalSignerWrappers[1].signerIdentification
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 1, "signerIdentification")
                  }
                  readOnly={readOnly}
                />
                {errors["signerId-1"] && (
                  <ErrorMessage error={errors["signerId-1"]} />
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryName}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signers3"
                  name="signers3"
                  type="text"
                  autoComplete="off"
                  placeholder={t(
                    "providers.manual.form.signersName.placeholder"
                  )}
                  value={
                    institution.legalSignerWrappers[2] !== undefined
                      ? institution.legalSignerWrappers[2].signerName
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 2, "signerName")
                  }
                  readOnly={readOnly}
                />
                {errors["signerName-2"] && (
                  <ErrorMessage error={errors["signerName-2"]} />
                )}
              </div>
              <div className="row-file col-lg-6 col-md-6 col-sm-12">
                <label className="label">{details.signatoryID}</label>
                <input
                  className="input input--text input-w-aux__input input--active"
                  id="signersId3"
                  name="signersId3"
                  type="text"
                  autoComplete="off"
                  placeholder={t("providers.manual.form.signersId.placeholder")}
                  value={
                    institution.legalSignerWrappers[2] !== undefined
                      ? institution.legalSignerWrappers[2].signerIdentification
                      : ""
                  }
                  onChange={(e) =>
                    this.handlerSignersChange(e, 2, "signerIdentification")
                  }
                  readOnly={readOnly}
                />
                {errors["signerId-2"] && (
                  <ErrorMessage error={errors["signerId-2"]} />
                )}
              </div>
            </div>
            <div className="form-actions clearfix">
              {readOnly === true ? (
                <SecondaryButton
                  className="btnLimpiar"
                  onClick={() => this.goBack()}
                >
                  {buttons.back}
                </SecondaryButton>
              ) : (
                <React.Fragment>
                  <SecondaryButton
                    className="btnLimpiar"
                    onClick={this.onCancelEdit}
                  >
                    {buttons.cancel}
                  </SecondaryButton>
                  <SecondaryButton
                    className="btnAgregar"
                    onClick={
                      this.enableActionsButton()
                        ? this.UpdateProvider
                        : undefined
                    }
                    disabled={!this.enableActionsButton()}
                  >
                    {buttons.sendForApproval}
                  </SecondaryButton>
                </React.Fragment>
              )}
            </div>
          </Fragment>
        )}
        <Modal
          key={`provider-users`}
          show={modal.show}
          handleClose={modal.onClose}
        >
          {modal.content}
        </Modal>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    providerInfo: getOneProvider(state),
    roles: getRoles(state),
    achbanks: getAchBanks(state),
    countries: getCountries(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
    countryActions: bindActionCreators(CountriesActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(ProviderProfile))
);
